/**
 * The House filter's "in no house yet" choice — sent as `houseUuid=NONE`,
 * which the server reads as `houseId IS NULL`. Shared by the register, its
 * export and the Houses page, which links to it.
 */
export const NO_HOUSE = 'NONE';

/** What every screen calls a student with no house. */
export const NOT_ASSIGNED_LABEL = 'Not assigned';
